import { Language } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useLanguagePersistence } from '../hooks/useLanguagePersistence';
import { languages } from '../utils/language';

const LanguageSwitcher = React.memo(() => {
  const { t } = useTranslation();
  const currentLanguage = useSelector(state => state.ui.language);
  const { changeLanguage } = useLanguagePersistence();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleLanguageChange = useCallback(
    language => {
      changeLanguage(language);
      handleClose();
    },
    [changeLanguage, handleClose]
  );

  // use shared languages list

  const currentLang = useMemo(
    () => languages.find(lang => lang.code === currentLanguage) || languages[0],
    [currentLanguage]
  );
  return (
    <Box
      style={
        process.env.REACT_APP_ENV === 'development' ? {} : { display: 'none' }
      }
    >
      <Button
        onClick={handleClick}
        startIcon={<Language />}
        sx={{
          color: theme =>
            theme.palette.mode === 'light'
              ? theme.palette.text.primary
              : 'inherit',
          textTransform: 'none',
        }}
        aria-label={t('common.language')}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <img
            src={currentLang.flagUrl}
            alt={currentLang.name}
            style={{
              width: '20px',
              height: '15px',
              borderRadius: '2px',
              objectFit: 'cover',
            }}
          />
          <Typography
            variant='body2'
            sx={theme => ({
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.text.primary
                  : 'inherit',
            })}
          >
            {currentLang.name}
          </Typography>
        </Box>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {languages.map(language => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={currentLanguage === language.code}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              minWidth: 120,
            }}
          >
            <img
              src={language.flagUrl}
              alt={language.name}
              style={{
                width: '20px',
                height: '15px',
                borderRadius: '2px',
                objectFit: 'cover',
              }}
            />
            <Typography>{language.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
});

LanguageSwitcher.displayName = 'LanguageSwitcher';

export default LanguageSwitcher;
